import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import "./Homepage.css";
function Navbar() {
  return <div className="nav-bar">Sorting Visualizer</div>;
}

export default Navbar;
